import Check from '@/components/Check';
import Tooltip from '@/components/Tooltip';
import buyCertificationLink from '@/domain/buyCertificationLink';
import { CertificationNumberDivider } from './CertificationNumber';

function CertificationCardItem({
  label,
  value,
}) {
  return (
    <div className="flex items-center space-x-4 lg:h-8">
      <h4 className="font-semibold text-base leading-5 text-gray-800">
        {label}
      </h4>
      <CertificationNumberDivider />
      <div>
        {value}
      </div>
    </div>
  );
}

export default function CertificationCard({
  info,
}) {
  const hasProduct = info.product !== null;
  const hasPrice = hasProduct && info.product.price !== null;
  const hasExam = info.certificacionWithExam !== null && info.certificacionWithExam === true;
  const hasTraining = info.training !== null;
  const hasAcclaimBadge = info.aacclaim !== null;

  return (
    <div className="rounded-xl shadow-lg bg-white">
      <div className="rounded-lg">
        <div className="w-full px-5 py-4 space-y-2 lg:space-y-0">
          {hasPrice && (
            <CertificationCardItem
              label="Precio"
              value={(
                <div className="font-mono text-lg text-green-600">
                  {info.product.price}
                </div>
              )}
            />
          )}
          {hasExam && (
            <CertificationCardItem
              label="Realiza examen"
              value={
                <Tooltip tooltip="Sí">
                  <button className="block text-green-400 hover:text-green-600 focus:outline-none" type="button">
                    <Check />
                  </button>
                </Tooltip>
              }
            />
          )}
          {hasTraining && (
            <CertificationCardItem
              label="Entrenamiento"
              value={
                <Tooltip tooltip={info.training.title}>
                  <button className="block text-green-400 hover:text-green-600 focus:outline-none" type="button">
                    <Check />
                  </button>
                </Tooltip>
              }
            />
          )}
          {hasAcclaimBadge && (
            <CertificationCardItem
              label="Insignia digital verificada"
              value={
                <Tooltip tooltip="Validado por Credly">
                  <button className="block text-green-400 hover:text-green-600 focus:outline-none" type="button">
                    <Check />
                  </button>
                </Tooltip>
              }
            />
          )}
        </div>
        <div className="flex items-center justify-end bg-gray-100 rounded-b-xl px-5 py-4">
          {hasProduct && (
            <a
              href={buyCertificationLink(info.product.databaseId)}
              className="block w-full text-center font-semibold bg-green-500 text-white px-6 py-2 leading-5 rounded-full text-base focus:outline-none hover:bg-green-600 focus:bg-green-600 focus:ring-4 focus:ring-green-200"
              target="_blank"
              rel="noopener noreferrer"
            >
              Certifícate hoy mismo
            </a>
          )}
          {!hasProduct && (
            <div className="w-full flex items-center justify-center space-x-2">
              <svg className="w-4 h-4 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <div className="flex-1 text-sm font-normal text-gray-600">
                Certificación no disponible en línea
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
